import { Player } from '@3pc/player-videojs';

const players = document.querySelectorAll('.video-player');

const playerConfig = {
  // These are the default options (if these suit your purpose the config object can be left empty - else you can overwrite them here or add more options):
};

players.length &&
  players.forEach(playerEl => {
    new Player({
      player: playerEl,
      config: playerConfig,
    }).init();
  });
